import { render } from "./LogoBox.vue?vue&type=template&id=e2508284&scoped=true"
import script from "./LogoBox.vue?vue&type=script&lang=js"
export * from "./LogoBox.vue?vue&type=script&lang=js"

import "./LogoBox.vue?vue&type=style&index=0&id=e2508284&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2508284"]])

export default __exports__